export default __webpack_public_path__ + "static/media/Linked_List_Deletion_3.53dc2f7c.gif";